const colors = {
  neutral: {
    50: "#F9FAFC",
    100: "#F1F5F9",
    200: "#E2E8F0",
    300: "#CBD5E1",
    400: "#94A3B8",
    500: "#64748B",
    600: "#475569",
    700: "#334155",
    800: "#1E293B",
    900: "#0F172A",
  },
  primary: {
    50: "#EFF6FE",
    100: "#DFEDFE",
    200: "#BED7FF",
    300: "#7AA8F4",
    400: "#2871EB",
    500: "#1954AE",
    600: "#002D72",
    700: "#071D49",
  },
  brandRed: {
    50: "#FDDDE5",
    100: "#FABBCB",
    300: "#EF3340",
    500: "#A71930",
  },
  brandError: {
    50: "#FFF0ED",
    100: "#FFE1DB",
    200: "#F9BDB0",
    300: "#FD8D75",
    400: "#FB6D4E",
    500: "#FF4B24",
    600: "#D5320F",
    700: "#9E2107",
  },
  brandWarning: {
    50: "#FFFCE1",
    100: "#FEF9C3",
    200: "#FEF08A",
    300: "#FDE047",
    400: "#FACC15",
    500: "#DBAC19",
    600: "#A17B03",
    700: "#715600",
  },
  brandSuccess: {
    50: "#E8FDF2",
    100: "#D1FAE5",
    200: "#A7F3D0",
    300: "#6EE7B7",
    400: "#34D399",
    500: "#059669",
    600: "#027A57",
    700: "#03563E",
  },
};

export default colors;
